import {
  EyeOff, FileSpreadsheet, Handshake, Hourglass, PhoneMissed, Users,
} from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

// Amden Growth green line icons per the product's visual identity.
const PROBLEM_ICONS = {
  'Leads in Spreadsheets and Inboxes': FileSpreadsheet,
  'Follow-Ups That Slip': PhoneMissed,
  'No Clear Pipeline': EyeOff,
  'Deals That Go Quiet': Hourglass,
  'No Team Visibility': Users,
  'Untracked Referrals': Handshake,
};

// Section 2 — the sales challenge.
export const ReachChallenge = ({ sp }) => (
  <section aria-labelledby="reach-challenge-heading" data-testid="reach-challenge" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="02"
        eyebrow="The Challenge"
        title="Sales rarely fail on effort — they fail on follow-through"
        description={sp.problemCopy}
        testid="reach-challenge-header"
      />
      <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {(sp.problems || []).map((problem, i) => {
          const Icon = PROBLEM_ICONS[problem.title] || FileSpreadsheet;
          return (
            <Reveal key={problem.title} delay={(i % 3) * 0.06} className="h-full">
              <li className="flex h-full flex-col rounded-xl border border-slate-200 bg-mist p-6" data-testid={`reach-problem-${i + 1}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-emerald-200 bg-emerald-50 text-service-growth">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-base font-extrabold tracking-tight text-navy-900">{problem.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{problem.text}</p>
              </li>
            </Reveal>
          );
        })}
      </ul>
    </div>
  </section>
);
